import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { StylesProvider, ThemeProvider as JssThemeProvider } from '@mui/styles'

import ReduxProvider from '../../core/redux'
import { theme } from '../../core/theme/constants/theme'
import IntlProvider from '../../core/i18n'
import { UserProvider } from '../../core/user'
import { AjaxProvider } from '../../core/ajax'
import { Modal as ModalProvider } from '../../ui/modal'
import { BootstrapRouter } from '../routers/bootstrap.router'
import OnCrash from '../onCrash/onCrash.component'
import { OnServerDown } from '../onServerDown/onServerDown.component'

export const BootstrapComponent = () => {
  return (
    <ReduxProvider>
      <StylesProvider injectFirst>
        <JssThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <IntlProvider>
              <UserProvider>
                <AjaxProvider>
                  <OnServerDown>
                    <OnCrash>
                      <BrowserRouter>
                        <ModalProvider>
                          <BootstrapRouter />
                        </ModalProvider>
                      </BrowserRouter>
                    </OnCrash>
                  </OnServerDown>
                </AjaxProvider>
                <ToastContainer limit={1} theme="colored" bodyClassName="toastClassName" />
              </UserProvider>
            </IntlProvider>
          </ThemeProvider>
        </JssThemeProvider>
      </StylesProvider>
    </ReduxProvider>
  )
}
